// Normalizes whatever the backend returns into a single contact object (POST create response)
export function xeroCreatedContactFromPostBody(body) {
  if (!body || typeof body !== 'object') {
    return undefined;
  }
  const nested = body.data;
  if (nested && typeof nested === 'object' && !Array.isArray(nested) && nested.contactId !== undefined) {
    return nested;
  }
  if (body.contactId !== undefined) {
    return body;
  }
  return undefined;
}

// Normalizes GET Xero contacts list response into a contact array (for useQuery `select`)
export function xeroContactsListFromResponse(body) {
  if (Array.isArray(body)) {
    return body;
  }
  if (body && Array.isArray(body.data)) {
    return body.data;
  }
  return [];
}
